import { AbstractControl, ValidatorFn } from '@angular/forms';
import { isNil, Nillable } from '@web/utils';
import { ValidationError, ValidationErrorParam } from '@web/shared/ui';
import { AdminBoxCharacteristics } from '../models/admin-box-details-form';

export class AdminBoxCharacteristicsValidator {
  public static min(count: number): ValidatorFn {
    return (control: AbstractControl<Nillable<AdminBoxCharacteristics>>) => {
      const { value } = control;

      if (!isNil(value)) {
        if (value?.items.length >= count) {
          return null;
        }
      }

      return {
        [ValidationError.Custom]: {
          [ValidationErrorParam.Message]: `Box kosmetyczny powinien zawierać co najmniej ${count} charakterystyk.`,
        },
      };
    };
  }
}
